import mainCaller from './mainCaller';

export async function getTemporaryUsersList(token, query) {
  return await mainCaller(`admin/api/v1/temporaryUser?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getTemporaryUserById(id, token) {
  return await mainCaller(`admin/api/v1/temporaryUser/${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  }).catch(error => {
    console.log(error);
  });
}

// 실패를 삼키지 않는 상세 조회 — 호출부가 실패를 구분해야 할 때 쓴다
export async function fetchTemporaryUserDetail(id) {
  return await mainCaller(`admin/api/v1/temporaryUser/${id}`, 'GET', null, {});
}

export async function updateTemporaryUser(data, id) {
  return await mainCaller(`admin/api/v1/temporaryUser/${id}`, 'PUT', data, {
    'Content-type': 'multipart/form-data',
  });
}

export async function deleteTemporaryUser(id, token) {
  return await mainCaller(`admin/api/v1/temporaryUser/${id}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  }).catch(error => {
    console.log(error);
  });
}

export async function createTemporaryUser(data) {
  return await mainCaller(`admin/api/v1/temporaryUser`, 'POST', data, {
    'Content-type': 'multipart/form-data',
  });
}

export async function checkUserName(data) {
  return await mainCaller(`admin/api/v1/auth/check/username`, 'POST', data, {});
}

// 앱 계정(ROLE_MEMBER) 아이디 중복확인 — 어드민 계정용 auth/check/username 과 판정 기준이 다르다
// temporaryUserId: 수정 중인 잠재회원 — 자기 예약 아이디는 사용 가능으로 본다.
export async function checkAppUsername(username, temporaryUserId) {
  const self = temporaryUserId ? `&temporaryUserId=${encodeURIComponent(temporaryUserId)}` : '';
  return await mainCaller(
    `admin/api/v1/temporaryUser/check-username?username=${encodeURIComponent(username)}${self}`,
    'GET',
    null,
    {},
  );
}

// branchOnly: 그 지점 회원만(잠재회원 등록·판매등록의 같은 번호 안내). 기본은 전 지점.
// includeTemporary: 그 지점의 같은 번호 잠재회원도 함께(잠재회원 등록 화면, 2026-10-28)
export async function searchUserByPhoneNumber(phoneNumber, branchId, branchOnly = false, includeTemporary = false) {
  return await mainCaller(
    `admin/api/v1/temporaryUser/search-user?phoneNumber=${phoneNumber}&branchId=${branchId}${branchOnly ? '&branchOnly=true' : ''}${includeTemporary ? '&includeTemporary=true' : ''}`,
    'GET',
    null,
    {},
  );
}

// 리스트 상단 통계 카드
export async function getTemporaryUserSummary(query) {
  return await mainCaller(`admin/api/v1/temporaryUser/summary?${query}`, 'GET', null, {});
}

// 방문경로/상담수단/운동목적 옵션 단일 소스
export async function getConsultOptions() {
  return await mainCaller(`admin/api/v1/enums/consult-options`, 'GET', null, {});
}
